import accordion from '~/scripts/components/accordion'
import registrationForm from '~/scripts/components/registrationForm'
import search from '~/scripts/components/search'
import bookshelfAlign from '~/scripts/components/BookshelfAlign'
import accordiontabs from '~/scripts/components/accordion-tabs'
import Events from '~/scripts/components/Events'
import Menus from '~/scripts/components/Menus'

document.documentElement.className = document.documentElement.className.replace('no-js', 'js');